module.exports = __webpack_public_path__ + "static/media/md-hourglass.6905b8dd.svg";